import script from "./StichComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./StichComponent.vue?vue&type=script&lang=ts&setup=true"

import "./StichComponent.vue?vue&type=style&index=0&id=3aee28aa&scoped=true&lang=css"

import exportComponent from "/home/node/skat32-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aee28aa"]])

export default __exports__